import ScrollMagic from 'scrollmagic'

let controller = new ScrollMagic.Controller();

let offset = innerWidth > 1024 ? innerWidth * 0.116913484021823850350740452065471551 : innerWidth * 0.15625

class ScrollFade {
    constructor() {
        this.ANIMATION_CLASS = 'is-fire';
        this.ANIMATION_END_CLASS = 'is-end';

        let $section = document.querySelectorAll('.Js-scroll:not(.is-fire)');
        if ($section.length === null) {
            return;
        }
        // let controller = new ScrollMagic.Controller();
        for (let i = 0; i < $section.length; i++) {
            let scene = new ScrollMagic.Scene({
                triggerElement: $section[i],
                triggerHook: 'onEnter',
                reverse: false,
                offset: 150
            })
                .addTo(controller);
            scene.on('enter', () => {
                $section[i].classList.add(this.ANIMATION_CLASS);
                setTimeout(() => {
                    $section[i].classList.add(this.ANIMATION_END_CLASS);
                }, 1500)
            });
            scene.on('end', () => {
                scene.destroy(true);
            });
        }
    }
}

new ScrollFade();